import React, { useEffect } from "react"

import { useStaticQuery, graphql } from "gatsby"
import PropTypes from "prop-types"

import favicon from "../images/favicon.png"
import Logo from "../images/share-image.jpg"

const Ad = () => {
  useEffect(() => {
    if (
      !document.querySelector(
        'script[src="https://lngtd.com/thegistsports.js"]'
      )
    ) {
      const script = document.createElement("script")
      script.src = "https://lngtd.com/thegistsports.js"
      script.async = true
      document.head.appendChild(script)
    }
  }, [])

  return null
}

const Head = ({
  description,
  lang,
  title,
  image,
  path,
  structuredData,
  prevPage,
  nextPage,
  children,
  canonical,
  isAd,
}) => {
  const { site, allSanityCountry, allSanitySocial, allSanityDictionary } =
    useStaticQuery(graphql`
      {
        allSanityDictionary {
          nodes {
            key {
              current
            }
            value
          }
        }
        site {
          siteMetadata {
            title
            description
            siteUrl
          }
        }
        allSanitySocial {
          nodes {
            urls {
              url
            }
          }
        }
        allSanityCountry {
          nodes {
            abbreviation
            url
          }
        }
      }
    `)
  const defaultTitle = allSanityDictionary.nodes.find(
    (item) => item.key.current === "title"
  )?.value
  const defaultDescription = allSanityDictionary.nodes.find(
    (item) => item.key.current === "description"
  )?.value
  const metaTitle = title ? `${title} | ${defaultTitle}` : defaultTitle
  const metaDescription = description || defaultDescription
  const metaImage = image || Logo

  return (
    <>
      <html lang={lang} />
      <title>{metaTitle}</title>
      <meta
        name="viewport"
        content="width=device-width, initial-scale=1, shrink-to-fit=no"
      />
      <meta name="description" content={metaDescription} />
      <meta property="og:title" content={metaTitle} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:type" content="website" />
      <meta property="og:image" content={metaImage} />
      <meta name="twitter:card" content="summary" />
      <meta name="twitter:creator" content={defaultTitle} />
      <meta name="twitter:title" content={metaTitle} />
      <meta name="twitter:description" content={metaDescription} />
      <meta name="google-adsense-account" content="ca-pub-5816649423064821" />
      <meta
        name="viewport"
        content="width=device-width, initial-scale=1, shrink-to-fit=no"
      />
      {prevPage ? (
        <link rel="prev" href={`${site.siteMetadata.siteUrl}${prevPage}`} />
      ) : (
        ""
      )}
      {nextPage ? (
        <link rel="next" href={`${site.siteMetadata.siteUrl}${nextPage}`} />
      ) : (
        ""
      )}
      {allSanityCountry.nodes.map((country) => (
        <link
          rel="alternate"
          href={`${country.url}${path}`}
          hrefLang={`${
            country.url.includes("www")
              ? "x-default"
              : `en-${country.abbreviation.toLowerCase()}`
          }`}
          key={`${
            country.url.includes("www")
              ? "x-default"
              : `en-${country.abbreviation.toLowerCase()}`
          }`}
        />
      ))}
      <link
        href="https://fonts.googleapis.com/icon?family=Material+Icons"
        rel="stylesheet"
      />
      {!isAd && <link rel="stylesheet" href="/hide_ads.css" />}
      <link
        rel="canonical"
        href={`${site.siteMetadata.siteUrl}${canonical || path}`}
      />
      <link rel="icon" type="image/png" href={favicon} />
      <script type="application/ld+json">
        {`
          {
            "@context": "http://www.schema.org",
            "@type": "Organization",
            "name": "${defaultTitle}",
            "url": "${site.siteMetadata.siteUrl}",
            "sameAs": [${allSanitySocial.nodes
              .map((urls) => urls.urls.map((url) => `"${url.url}"`))
              .toString()}
            ],
            "logo": "${site.siteMetadata.siteUrl}/logo.svg",
            "description": "${defaultDescription}",
            "address": {
              "@type": "PostalAddress",
              "addressCountry": "Canada"
            }
          }
        `}
      </script>
      <script
        type="text/javascript"
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{
          __html: `
          (function(c) {
            var script = document.createElement("script");
            script.src = "https://js.memberful.com/embed.js";
            script.onload = function() { Memberful.setup(c) };
            document.head.appendChild(script);
          })({
            site: ["https://plus.thegistsports.com"],
          });
          `,
        }}
      />

      <script
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{
          __html: `
            window.lngtdAdTargeting = {
              title: "${metaTitle}",
              url: "${path}"
            }
          `,
        }}
      />
      {isAd ? <Ad /> : ""}
      {structuredData ? (
        <script type="application/ld+json">{structuredData}</script>
      ) : (
        ""
      )}
      {children}
    </>
  )
}

export default Head

Head.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  title: PropTypes.string,
  image: PropTypes.string,
  path: PropTypes.string,
  structuredData: PropTypes.string,
  prevPage: PropTypes.string,
  nextPage: PropTypes.string,
  children: PropTypes.node,
  canonical: PropTypes.string,
  isAd: PropTypes.bool,
}

Head.defaultProps = {
  lang: "en",
  description: "",
  title: "",
  path: "",
  image: "",
  structuredData: "",
  prevPage: "",
  nextPage: "",
  children: null,
  canonical: "",
  isAd: false,
}
